<template>
  <div :class="'header-box'+(isFixed?'':' header-boxs')" :style="{'background-color':isFixed?'':'#19203B'}">
    <div class="header-center">
     <router-link to="/"><img class="logo" src="@/assets/imgs/common/logo.png" /></router-link>

      <div class="menu-ul mod-header">
        <router-link :class="{'menu-item':menuIndex==1}" to="/solution" class="has-sub more">
          解决方案
          <ul class="sub-nav" style="display: none; top: 104px; opacity: 0">
            <li>
              <router-link to="/solution?index=index1" class="s_btn">行业挑战</router-link>
            </li>
            <li>
              <router-link to="/solution?index=index2" class="s_btn">方案优势</router-link>
            </li>
            <li>
              <router-link to="/solution?index=index3" class="s_btn">方案价值</router-link>
            </li>
          </ul>
        </router-link>
        <router-link :class="{'menu-item':menuIndex==2}" to="/product" class="has-sub more"> 产品中心
          <ul class="sub-nav" style="display: none; top: 104px; opacity: 0;width: 220px;left: -80px">
            <li>
              <router-link to="/product?index=1" class="s_btn">预应力工程全数量检测系统</router-link>
            </li>
            <li>
              <router-link to="/product?index=2" class="s_btn">锚下预应力检测系统</router-link>
            </li>
            <li>
              <router-link to="/product?index=3" class="s_btn">预应力锚索基础试验系统</router-link>
            </li>
            <li>
              <router-link to="/product?index=4" class="s_btn">智能拉拔系统</router-link>
            </li>
            <li>
              <router-link to="/product?index=5" class="s_btn">远程监测系统</router-link>
            </li>
          </ul>
        </router-link>
        <router-link :class="{'menu-item':menuIndex==3}" to="/technological">技术创新</router-link>
        <router-link :class="{'menu-item':menuIndex==4}" to="/case" class="has-sub more">典型案例
          <ul class="sub-nav" style="display: none; top: 104px; opacity: 0;">
            <li>
              <router-link to="/case?index=4" class="s_btn">高速公路</router-link>
            </li>
            <li>
              <router-link to="/case?index=1" class="s_btn">软岩隧道</router-link>
            </li>
            <li>
              <router-link to="/case?index=2" class="s_btn">铁路桥梁</router-link>
            </li>
            <li>
              <router-link to="/case?index=3" class="s_btn">特殊桥梁</router-link>
            </li>
            <li>
              <router-link to="/case?index=5" class="s_btn">边坡工程</router-link>
            </li>
            <li>
              <router-link to="/case?index=6" class="s_btn">基坑工程</router-link>
            </li>
          </ul>
        </router-link>
<!--        <router-link :class="{'menu-item':menuIndex==5}" to="/news">新闻中心</router-link>-->
        <router-link :class="{'menu-item':menuIndex==7}" to="/dataCenter" class="has-sub more">技术支持
        </router-link>
        <router-link :class="{'menu-item':menuIndex==6}" class="has-sub more" to="">关于交达
          <ul class="sub-nav" style="display: none; top: 104px; opacity: 0;">
        <li>
          <router-link :class="{'menu-items':menuIndex==6}" to="/inRegard" class="s_btn">关于交达</router-link>
        </li>
          </ul>
        </router-link>
        <router-link :class="{'menu-item':menuIndex==8||menuIndex==9}" class="has-sub more" to="">联系我们
          <ul class="sub-nav" style="display: none; top: 104px; opacity: 0;">

            <li>
              <router-link to="/contactUs" :class="{'menu-items':menuIndex==8}" class="s_btn">联系我们</router-link>
            </li>
            <li>
              <router-link to="/joinUs" :class="{'menu-items':menuIndex==9}" class="s_btn">加入我们</router-link>
            </li>
          </ul>
        </router-link>
      </div>
    </div>

  </div>
</template>
<script type="text/javascript">
  export default {
    name: 'header2',
    props:["menuIndex"],
    data() {
      return {
        isFixed:true
      }
    },
    mounted() {
      $(function() {
        var fadetimeM;
        $(".mod-header .has-sub").hover(function() {
          var $this = $(this);
          var t = $(".mod-header").height() - $this.position().top + 20;
          clearTimeout(fadetimeM);
          $this.find(".trigger").addClass("open");
          $this.siblings(".has-sub").find(".trigger").removeClass("open");
          $this.find(".sub-nav").stop().show().animate({
            "top": t,
            "opacity": "1"
          }, 200).css({
            "flter": "Alpha(Opacity=100)"
          });
          $this.siblings(".has-sub").find(".sub-nav").stop().animate({
            "top": t + 40,
            "opacity": "0"
          }, 200, function() {
            $(this).hide();
          }).css({
            "flter": "Alpha(Opacity=0)"
          });
        }, function() {
          var $this = $(this);
          var t = $(".mod-header").height() - $this.position().top;
          fadetimeM = setTimeout(function() {
            $this.find(".trigger").removeClass("open");
            $this.find(".sub-nav").stop().animate({
              "top": t + 40,
              "opacity": "0"
            }, 200, function() {
              $(this).hide();
            }).css({
              "flter": "Alpha(Opacity=0)"
            });
          }, 300);
        });

      });
      window.addEventListener('scroll',this.handleScroll)
    },
    methods: {
      handleScroll(){
          let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop // 滚动条偏移量
          this.isFixed = scrollTop > 80 ? false : true; // 如果滚动到顶部了，this.isFixed就为true
      }
    },
  }
</script>
<style scoped>
  .sub-nav {
    opacity: 0;
    display: none;
    filter: alpha(opacity=0);
    position: absolute;
    top: 104px;
    width: 75px;
    border-radius: 10px;
    left: -25%;
    padding: 20px;
    background: #f9f9f9;
    z-index: 1000;
  }

  .sub-nav li{
    margin-bottom: 20px;
    display: block;
  }
  .menu-items{
    color: #0071EF !important;
    position: relative;
  }
  .header-boxs .sub-nav .s_btn{
    color: rgba(25, 32, 59, 1) !important;
  }
  .sub-nav li:last-child{
    margin-bottom: 0;
  }
  .sub-nav a{
    margin-left: 0 !important;
  }
  .menu-item{
    color: #FFFFFF !important;
    position: relative;
  }

  .menu-item:after{
    content: " ";
    height: 4px;
    width: 110%;
    position: absolute;
    background: #FFFFFF;
    left: -2%;
    top: 47px;
  }

  .header-box{
    width: 100%;
    height: 80px;
    box-shadow: 0px 20px 200px 1px rgba(0,0,0,0.0500);
    display: flex;
    justify-content: center;
    align-items: center;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 99;
    background-color: rgba(255, 255, 255, 0);
    color: #ffffff;
  }
  .header-boxs{
    transition: all 1500ms ease;
  }
  .header-boxs a{
    color: #ffffff !important;
  }

  .header-box .header-center{
    width: 1200px;
    margin: 0 auto;
    display: flex;
  }
  .header-box .logo{
    width: 180px;
  }
  .header-box .menu-ul{
    display: flex;
    align-items: center;
  }
  .header-box .menu-ul .has-sub{
    position: relative;
  }
  .header-box .menu-ul a{
    margin-right: 40px;
    font-size: 18px;
    text-decoration:none;
    font-weight: bold;
    color: rgba(25, 32, 59, 1);
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    cursor: pointer;
  }
  .header-box .menu-ul a:nth-child(1){
    margin-left: 120px;
  }
  .header-box .menu-ul a:last-child{
    margin-right: 0;
  }
  .header-box .menu-ul a:hover{
    color: #0071EF;
  }
</style>



// WEBPACK FOOTER //
// src/components/header.vue